import React, { useState, useEffect, useMemo } from 'react';

import _ from 'lodash';
import { TextField, Grid } from '@mui/material';
import { PhoneNumberField } from 'src/components/phone-number-field';
import StateAutocomplete from 'src/components/state-auto-complete';
import useAutoFocus from 'src/hooks/use-auto-focus';

const ProfileForm = ({ initialData, onChange }) => {
  // Format the initial date value if it exists
  const formatInitialDate = (date) => {
    if (!date) return '';
    // Handle different date formats that might come from initialData
    try {
      const d = new Date(date);
      if (Number.isNaN(d.getTime())) return '';
      return d.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    } catch (e) {
      console.error('Date parsing error:', e);
      return '';
    }
  };

  const [formData, setFormData] = useState({
    ...initialData,
    dob: formatInitialDate(initialData?.dob),
  });

  const isValid = useMemo(
    () =>
      !_.isEmpty(formData?.firstName) &&
      !_.isEmpty(formData?.lastName) &&
      // !_.isEmpty(formData?.addressLine1) &&
      // !_.isEmpty(formData?.city) &&
      // !_.isEmpty(formData?.state) &&
      // /^\d{5}(?:[-\s]\d{4})?$/.test(formData?.zip) &&
      !_.isEmpty(formData?.dob)
  );

  const firstNameRef = useAutoFocus();

  useEffect(() => {
    onChange({ ...formData, displayName: `${formData.firstName} ${formData.lastName}` }, isValid);
  }, [isValid, formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <form>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            inputRef={firstNameRef}
            fullWidth
            label="First Name"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Last Name"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Date of Birth"
            name="dob"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={formData?.dob ?? ''}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Address Line 1"
            name="addressLine1"
            value={formData.addressLine1}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Address Line 2"
            name="addressLine2"
            value={formData.addressLine2}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="City"
            name="city"
            value={formData.city}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={3}>
          <StateAutocomplete value={formData.state} onChange={handleChange} />
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            label="ZIP Code"
            name="zip"
            value={formData.zip}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6}>
          <PhoneNumberField
            fullWidth
            label="Phone Number (optional)"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default ProfileForm;
